module.exports = __webpack_public_path__ + "static/media/hero_desktop.40780c92.webp";